import React, { Component } from "react";
import { Row, Col, Modal, Typography, Form, Statistic, Spin, Divider, Descriptions, Tag, Card } from 'antd';

const { Title, Text } = Typography;
const axios = require('axios').default;
const moment = require('moment');



/**
 *
 *
 * @class ModalCompraDetalle
 * @extends {Component}
 */
class ModalCompraDetalle extends Component {


    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            factura: {},
            transaccion: null,
            razon_social: null,
            proveedor: null
        }

    }

    componentDidMount() {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');
    }

    render() {
        const { orden } = this.props;

        if (!orden) {
            return (
                <Form layout="vertical">
                    <Title level={3} className="text-center mb-3">Detalle Orden</Title>
                    <Text type="secondary">No hay información disponible</Text>
                </Form>
            );
        }

        console.log('orden', orden);

        return (
            <Spin spinning={this.state.loading}>
                <div style={{ padding: '8px' }}>
                    <Title level={4} style={{ margin: '0 0 24px 0' }}>
                        {orden.folio || 'N/A'}
                    </Title>

                    {/* Información General */}
                    <Descriptions 
                        size="small" 
                        column={{ xs: 1, sm: 2, md: 2 }}
                        bordered
                        style={{ marginBottom: '20px' }}
                    >
                        <Descriptions.Item label="Fecha de Orden">
                            {orden.createdAt 
                                ? moment(orden.createdAt).format('LL') 
                                : orden.cotizacion_id?.fecha 
                                ? moment(orden.cotizacion_id.fecha).format('LL')
                                : 'N/A'}
                        </Descriptions.Item>
                        <Descriptions.Item label="Fecha Límite">
                            {orden.fecha_limite 
                                ? moment(orden.fecha_limite).format('LL') 
                                : 'N/A'}
                        </Descriptions.Item>
                        <Descriptions.Item label="Cliente" span={2}>
                            <Text strong>
                                {orden.cliente?.nombre_completo || 
                                 orden.cliente_id?.nombre_completo || 
                                 'N/A'}
                            </Text>
                        </Descriptions.Item>
                    </Descriptions>

                    <Divider orientation="left" style={{ margin: '20px 0' }}>
                        <Text type="secondary">Producto</Text>
                    </Divider>

                    {/* Información del Producto */}
                    <Card size="small" style={{ marginBottom: '20px', backgroundColor: '#fafafa' }}>
                        <div style={{ marginBottom: '8px' }}>
                            <Text strong style={{ fontSize: '15px' }}>
                                {orden.inventario_producto?.np_cliente || 
                                 orden.producto_id?.np_cliente || 
                                 'N/A'}
                            </Text>
                        </div>
                        <div style={{ marginBottom: '8px' }}>
                            <Text type="secondary">
                                {orden.producto_id?.descripcion || 
                                 orden.orden_detalles?.producto_id?.descripcion || 
                                 'Sin descripción'}
                            </Text>
                        </div>
                        <div style={{ fontSize: '12px', color: '#8c8c8c' }}>
                            {orden.producto_id?.marca || 
                             orden.orden_detalles?.producto_id?.marca || ''} 
                            {orden.producto_id?.np_fabricante 
                                ? ` | NP Fabricante: ${orden.producto_id.np_fabricante}` 
                                : ''}
                        </div>
                    </Card>

                    <Descriptions 
                        size="small" 
                        column={{ xs: 1, sm: 2, md: 2 }}
                        bordered
                        style={{ marginBottom: '20px' }}
                    >
                        <Descriptions.Item label="Cantidad">
                            <Text strong>
                                {orden.orden_detalles?.cantidad || 
                                 orden.orden_detalles_simple?.[0]?.cantidad || 
                                 0}
                            </Text> {orden.producto_id?.unidad_nombre || 'unidad(es)'}
                        </Descriptions.Item>
                        <Descriptions.Item label="Almacén">
                            {orden.almacen_id?.direccion || 
                             orden.almacen?.direccion || 
                             'N/A'}
                        </Descriptions.Item>
                    </Descriptions>

                    <Divider orientation="left" style={{ margin: '20px 0' }}>
                        <Text type="secondary">Resumen Financiero</Text>
                    </Divider>

                    {/* Totales */}
                    <Row gutter={[16, 16]} justify="space-around" style={{ textAlign: 'center' }}>
                        <Col xs={8}>
                            <Card size="small" bordered={false} style={{ backgroundColor: '#f0f5ff' }}>
                                <Statistic
                                    title="Subtotal"
                                    value={orden.subtotal || 0}
                                    precision={2}
                                    valueStyle={{ fontSize: '18px', color: '#1890ff' }}
                                    prefix={'$'}
                                />
                            </Card>
                        </Col>
                        <Col xs={8}>
                            <Card size="small" bordered={false} style={{ backgroundColor: '#fff7e6' }}>
                                <Statistic
                                    title="Impuestos"
                                    value={orden.impuestos || 0}
                                    precision={2}
                                    valueStyle={{ fontSize: '18px', color: '#fa8c16' }}
                                    prefix={'$'}
                                />
                            </Card>
                        </Col>
                        <Col xs={8}>
                            <Card size="small" bordered={false} style={{ backgroundColor: '#f6ffed' }}>
                                <Statistic
                                    title="Total"
                                    value={orden.total || 0}
                                    precision={2}
                                    valueStyle={{ fontSize: '18px', color: '#52c41a', fontWeight: 'bold' }}
                                    prefix={'$'}
                                />
                            </Card>
                        </Col>
                    </Row>
                </div>
            </Spin>
        );
    }
}



export default function (props) {
    const { visible = false, onClose = () => { } } = props

    return <Modal
        visible={visible}
        onCancel={onClose}
        title="Detalle de Orden de Compra"
        footer={null}
        closable={true}
        destroyOnClose={true}
        zIndex={1000}
        width={700}
    >
        <ModalCompraDetalle {...props} />
    </Modal>

}